import * as React from "react";
import { Route, Switch } from "react-router-dom";

// OIDC Authentication components
// to manage the user session state
import { Callback } from "../components/auth/callback";
import { Logout } from "../components/auth/logout";
import { LogoutCallback } from "../components/auth/logoutCallback";
import { PrivateRoute } from "./privateRoute";
import { SilentRenew } from "../components/auth/silentRenew";

// Vehicle Hub Components
import NotFound from "../components/pages/NotFound/NotFound"

// Components
import Dashboard from '../components/pages/Dashboard/Dashboard';
import Trim from '../components/pages/Trim/Trim';
import TrimDetail from '../components/pages/TrimDetail/TrimDetail';
import DiscountIncentive from '../components/pages/DiscountIncentive/DiscountIncentive';
import DiscountIncentiveDetail from '../components/pages/DiscountIncentiveDetail/DiscountIncentiveDetail';
import Pricing from '../components/pages/Pricing/Pricing';
import PricingDetail from '../components/pages/PricingDetail/PricingDetail';
import StandardFeature from '../components/pages/StandardFeature/StandardFeature';
import StandardFeatureDetail from '../components/pages/StandardFeatureDetail/StandardFeatureDetail';
import Color from '../components/pages/Color/Color';
import ColorDetail from '../components/pages/ColorDetail/ColorDetail';
import Upholstery from '../components/pages/Upholstery/Upholstery';
import UpholsteryDetail from '../components/pages/UpholsteryDetail/UpholsteryDetail';
import Package from '../components/pages/Package/Package';
import PackageDetail from '../components/pages/PackageDetail/PackageDetail';
import Option from '../components/pages/Option/Option';
import OptionDetail from '../components/pages/OptionDetail/OptionDetail';
import Accessory from "../components/pages/Accessory/Accessory";
import AccessoryDetail from "../components/pages/AccessoryDetail/AccessoryDetail";
import Model from '../components/pages/Model/Model';
import ModelDetail from '../components/pages/ModelDetail/ModelDetail';
import Engine from '../components/pages/Engine/Engine';
import EngineDetail from '../components/pages/EngineDetail/EngineDetail';
import SalesVersion from '../components/pages/SalesVersion/SalesVersion';
import SalesVersionDetail from '../components/pages/SalesVersionDetail/SalesVersionDetail';
import SalesChannel from '../components/pages/SalesChannel/SalesChannel';
import SalesChannelDetail from '../components/pages/SalesChannelDetail/SalesChannelDetail';
import Gearbox from '../components/pages/Gearbox/Gearbox';
import GearboxDetail from '../components/pages/GearboxDetail/GearboxDetail';
import VistaOrder from "../components/pages/VistaOrder/VistaOrder";
import VistaOrderDetail from "../components/pages/VistaOrderDetail/VistaOrderDetail";

export const Routes = (
    <Switch>

        {/* Public routes that trigger the OIDC authentication components  */}
        <Route exact={true} path="/signin-oidc" component={Callback} />
        <Route exact={true} path="/logout" component={Logout} />
        <Route exact={true} path="/logout/callback" component={LogoutCallback} />
        <Route exact={true} path="/silentrenew" component={SilentRenew} />

        {/* Private Routes to content that requires authentication */}
        {/* <PrivateRoute path="/dashboard" component={Dashboard} /> */}
        <PrivateRoute path="/vehicle/:itemId" component={TrimDetail} />
        <PrivateRoute path="/vehicle" component={Trim} />
        <PrivateRoute path="/discount/:itemId" component={DiscountIncentiveDetail} />
        <PrivateRoute path="/discount" component={DiscountIncentive} />
        <PrivateRoute path="/pricing/:itemId" component={PricingDetail} />
        <PrivateRoute path="/pricing" component={Pricing} />
        <PrivateRoute path="/standard-feature/:itemId" component={StandardFeatureDetail} />
        <PrivateRoute path="/standard-feature" component={StandardFeature} />
        <PrivateRoute path="/color/:itemId" component={ColorDetail} />
        <PrivateRoute path="/color" component={Color} />
        <PrivateRoute path="/upholstery/:itemId" component={UpholsteryDetail} />
        <PrivateRoute path="/upholstery" component={Upholstery} />
        <PrivateRoute path="/package/:itemId" component={PackageDetail} />
        <PrivateRoute path="/package" component={Package} />
        <PrivateRoute path="/option/:itemId" component={OptionDetail} />
        <PrivateRoute path="/option" component={Option} />
        <PrivateRoute path="/accessory/:itemId" component={AccessoryDetail} />
        <PrivateRoute path="/accessory" component={Accessory} />
        <PrivateRoute path="/vista-order/:itemId" component={VistaOrderDetail} />
        <PrivateRoute path="/vista-order" component={VistaOrder} />

        <PrivateRoute path="/model/:itemHash" component={ModelDetail} />
        <PrivateRoute path="/model" component={Model} />
        <PrivateRoute path="/engine/:itemHash" component={EngineDetail} />
        <PrivateRoute path="/engine" component={Engine} />
        <PrivateRoute path="/sales-version/:itemHash" component={SalesVersionDetail} />
        <PrivateRoute path="/sales-version" component={SalesVersion} />
        <PrivateRoute path="/sales-channel/:itemId" component={SalesChannelDetail} />
        <PrivateRoute path="/sales-channel" component={SalesChannel} />
        <PrivateRoute path="/transmission/:itemHash" component={GearboxDetail} />
        <PrivateRoute path="/transmission" component={Gearbox} />
        <PrivateRoute path="/" component={Dashboard} />

        {/* Catch-all for unknown routes */}
        <Route component={NotFound} />

    </Switch>
);
